import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';
import { Router } from '@angular/router';

export const acceptInviteParamGuard: CanMatchFn = () => {
  const router = inject(Router);
  const queryParamMap = router.currentNavigation()?.initialUrl.queryParamMap;
  const userIdParam = queryParamMap?.get('userId');
  const tenantIdParam = queryParamMap?.get('tenantId');
  const inviteCodeParam = queryParamMap?.get('inviteCode');

  if (!queryParamMap) {
    return false;
  }

  if (userIdParam && tenantIdParam && inviteCodeParam) {
    return true;
  }

  return false;
};
